import * as svg from "../../../assets/logo-black.svg";

import {iconBuilder} from "./iconBuilder";

export const LogoBlack = iconBuilder(svg, "LogoBlack", "0 0 360 72.3");
